import HttpHelpers from './helpers';

const ActivitiesApiEndpoints = {
  getActivities: (params) => {
    return HttpHelpers.unAuthenticatedAxios
      .get('activity', { params })
      .then((response) => response.data);
  },

  getActivitiesWithSubactivities: () => {
    return HttpHelpers.unAuthenticatedAxios
      .get('activity?with[]=sub-activities')
      .then((response) => response.data);
  },

  getSubActivities: (id) => {
    return HttpHelpers.unAuthenticatedAxios
      .get(`activity/${id}/sub-activity`)
      .then((response) => response.data);
  },

  getActivityDetails: (id) => {
    return HttpHelpers.unAuthenticatedAxios
      .get(`activity/${id}`)
      .then((response) => response.data);
  },

  activitiesLookup: (params) => {
    return HttpHelpers.unAuthenticatedAxios
      .get('activity/search', { params })
      .then((response) => response.data);
  },
};

export default ActivitiesApiEndpoints;
